import { render, staticRenderFns } from "./SupplierGoodsList.vue?vue&type=template&id=ebec7702&scoped=true&"
import script from "./SupplierGoodsList.vue?vue&type=script&lang=ts&"
export * from "./SupplierGoodsList.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierGoodsList.vue?vue&type=style&index=0&id=ebec7702&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebec7702",
  null
  
)

export default component.exports